var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.019,
    height: 54.019,
    viewBox: "0 0 54.019 54.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M5.243,41.15,38.684,7.708,47.6,16.622,14.156,50.064Z",
    transform: "translate(-0.522 -0.767)",
    fill: "#00824f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M55.536,12.035l1.273-1.273a6.3,6.3,0,1,0-8.915-8.914L46.621,3.12Z",
    transform: "translate(-4.637 0)",
    fill: "#00824f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M3.691,46.527.046,57.461A.9.9,0,0,0,.9,58.646a.889.889,0,0,0,.285-.047l10.933-3.644Z",
    transform: "translate(0 -4.628)",
    fill: "#00824f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M43.793,6.153l1.274-1.274,8.914,8.914-1.274,1.274Z",
    transform: "translate(-4.356 -0.485)",
    fill: "#00824f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c429ddb74b7f6a3ac33e160f2d99e337.svg";
export { ForwardRef as ReactComponent };